// components
import ReactForm from "./components/ReactForm";

const App = () => {
  return <ReactForm />;
};

export default App;